export type CapacitorEvidenceAccordionItem = {
    title: string;
    paragraphs: [string, string];
};

export const CAPACITOR_EVIDENCE_SUMMARY_SUBTITLE = 'Based on load and temperature';

export const CAPACITOR_EVIDENCE_ACCORDION_ITEMS: CapacitorEvidenceAccordionItem[] = [
    {
        title: 'How Long Capacitors Typically Last',
        paragraphs: [
            "In practice, you can estimate expected service life based on the manufacturer's rated lifespan assuming the device is maintained under nominal rated operating temperature and does not endure several charge and discharge cycles which occur outside of its specified parameters over a specified period.",
            "Component vendors expect their capacitors to deliver at least five years of round-the-clock service and seven years of shelf life. Eaton's experience is that these capacitors often last seven to 10 years, but failures are possible any time after the manufacturer's rated service life, and increase in likelihood, as the capacitor gets older.",
        ],
    },
    {
        title: 'How Capacitors Degrade Over Time Under Normal Use',
        paragraphs: [
            "In practice, you can estimate expected service life based on the manufacturer's rated lifespan assuming the device is maintained under nominal rated operating temperature and does not endure several charge and discharge cycles which occur outside of its specified parameters over a specified period.",
            "Component vendors expect their capacitors to deliver at least five years of round-the-clock service and seven years of shelf life. Eaton's experience is that these capacitors often last seven to 10 years, but failures are possible any time after the manufacturer's rated service life, and increase in likelihood, as the capacitor gets older.",
        ],
    },
];
